/** Real-time data (polymarket odds, on-chain activity). */
export const REALTIME_CACHE = { next: { revalidate: 30 } } as const;

/** Incident / announcement data (Ghost banners). Short TTL for freshness. */
export const SHORT_CACHE = { next: { revalidate: 60 } } as const;

/** Slightly stale-tolerant data. */
export const MEDIUM_CACHE = { next: { revalidate: 120 } } as const;

/** Infrequently changing data (SEO pages, public metadata). */
export const LONG_CACHE = { next: { revalidate: 300 } } as const;
